import { add, differenceInDays, Duration, format, formatISODuration, intervalToDuration } from 'date-fns';

export const formatPeriod = (startDate: Date, endDate: Date): string => {
  const duration = intervalToDuration({
    start: startDate,
    end: endDate,
  });
  return formatISODuration(duration);
};

export const date = (date: Date) => format(date, 'yyyy-MM-dd');

const numbers = '\\d+';
const fractionalNumbers = `${numbers}(?:[\\.,]${numbers})?`;
const datePattern = `(${numbers}Y)?(${numbers}M)?(${numbers}W)?(${numbers}D)?`;
const timePattern = `T(${fractionalNumbers}H)?(${fractionalNumbers}M)?(${fractionalNumbers}S)?`;

const iso8601 = `P(?:${datePattern}(?:${timePattern})?)`;

const objMap: (keyof Duration)[] = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];

/**
 * The ISO8601 regex for matching / testing durations
 */
export const pattern = new RegExp(iso8601);

/** Parse PnYnMnDTnHnMnS format to object */
export const parsePeriod = (durationString: string): Duration => {
  const matches = durationString.replace(/,/g, '.').match(pattern);
  if (!matches) {
    throw new RangeError(`invalid duration: ${durationString}`);
  }
  // Slice away first entry in match-array (the input string)
  const slicedMatches: (string | undefined)[] = matches.slice(1);
  if (slicedMatches.filter((v) => v != null).length === 0) {
    throw new RangeError(`invalid duration: ${durationString}`);
  }
  // Check only one fraction is used
  if (slicedMatches.filter((v) => /\./.test(v || '')).length > 1) {
    throw new RangeError('only the smallest unit can be fractional');
  }

  return slicedMatches.reduce((prev, next, idx) => {
    const objectMapIndex = objMap[idx] as keyof Duration;
    prev[objectMapIndex] = parseFloat(next || '0') || 0;
    return prev;
  }, {} as Duration);
};

export const parsePeriodToDays = (durationString: string): number => {
  const duration = parsePeriod(durationString);

  return differenceInDays(add(new Date(), duration), new Date());
};
